import {
  TableCell as MuiTableCell,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
} from "@mui/material";

const TableHeader = ({ columns, actionColumn, showBorder }) => {
  const isHasChildrenCols = columns.some((col) => col.children);

  return (
    <MuiTableHead sx={{ bgcolor: ({ palette }) => palette.grey[50] }}>
      <MuiTableRow>
        {columns?.map((col) => (
          <MuiTableCell
            key={col.id}
            align={col.align}
            width={col.width}
            rowSpan={!col.children && isHasChildrenCols ? 2 : 1}
            colSpan={col.children ? col.children.length : 1}
            sx={{
              ...(showBorder && {
                border: "1px solid rgba(224, 224, 224, 1)",
              }),
            }}>
            {col.name}
          </MuiTableCell>
        ))}

        {actionColumn && (
          <MuiTableCell
            align="center"
            width={actionColumn.width || 120}
            rowSpan={isHasChildrenCols ? 2 : 1}
            sx={{
              ...(showBorder && {
                border: "1px solid rgba(224, 224, 224, 1)",
              }),
            }}>
            Hành động
          </MuiTableCell>
        )}
      </MuiTableRow>

      {isHasChildrenCols && (
        <MuiTableRow>
          {columns
            ?.filter((col) => col.children)
            ?.map((col) => col.children)
            ?.flat()
            ?.map((col) => (
              <MuiTableCell
                key={col.id}
                align={col.align}
                width={col.width}
                sx={{
                  ...(showBorder && {
                    border: "1px solid rgba(224, 224, 224, 1)",
                  }),
                }}>
                {col.name}
              </MuiTableCell>
            ))}
        </MuiTableRow>
      )}
    </MuiTableHead>
  );
};

export default TableHeader;
